<template>
    <div>
        <div class="card_content" @click="sendData()" data-toggle="tooltip"
             data-placement="top"
             :title="upgrade">
            <div class="img">
                <img class="icon" :src="`${this.view.group.img}?v=${version}`" :alt="this.view.group.name" :title="this.view.group.name"/>
            </div>
            <div class="content">
                <div class="text title">{{ this.view.title.toLowerCase() }}</div>
                <div class="text description">{{ this.view.description.substring(0, 100).toLowerCase() + (this.view.description.length > 100 ? '...' : '') }}</div>
            </div>
        </div>
        <div class="line"/>
    </div>
</template>

<script>
export default {
    name: "CardTutorial",
    props: {
        view: {
            type: Object,
        },
        version: null,
        is_free_plan: null,
        routes: null,
        upgrade: null
    },
    data() {
        return {
        }
    },

    mounted() {
        if (this.is_free_plan == true) {
            $('.card_content').tooltip('enable')
        } else {
            $('.card_content').tooltip('disable')
        }

        if(this.view.group.img.endsWith('/cheetah_builder.svg')) {
          this.view.group.img = this.view.group.img.replace('/cheetah_builder.svg', '/builderall_builder.svg');
          this.view.group.name = 'Builderall Builder';
        }
        else if(this.view.group.img.endsWith('/cheetah_funnel_builder.svg')) {
          this.view.group.img = this.view.group.img.replace('/cheetah_funnel_builder.svg', '/builderall_funnel_builder.svg');
          this.view.group.name = 'Builderall Funnel Builder';
        }
    },

    methods: {
        async sendData() {
            // if (this.is_free_plan == true){
            //     window.open(this.routes.rota_office_upgrade + '?is_free_plan=true', '_self')
            // } else {
            //     window.open(this.view.href, '_blank')
            //     await axios.post(`https://intelligence.builderall.com/amount/` + this.view.id);
            // }
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../../../../scss/extras/_variables";
.card_content {
    margin: 1em 0;
    cursor: pointer;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    display: flex;
    .icon {
        width: auto;
        height: 90px;
        margin: -1em 0 0 -1em;
    }
    .content {
        .text {
            font-size: 12px;
            text-align: left;
            text-justify: inter-word;
            text-transform: capitalize;
        }
        .title {
            color: $dv5-color1;
            font-family: $dv5-font1;
            font-weight: 700;
        }
        .description {
            color: $of-color12;
            font-family: $dv5-font2;
            font-weight: 500;
        }
    }
}
.line {
    background-color: #7070703d;
    height: 1px;
    width: 98%;
    opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/tutorial/components/CardTutorial.vue